import {components} from 'react-select';
import type {DropdownIndicatorProps, GroupBase} from 'react-select';
import {SelectOption} from '@chekin/core';
import {CustomIcon, IconNames} from '../../CustomIcon';
import {CustomIconContainer, DisplayIcon, StyledCustomIcon} from './styled';
import type {SelectProps} from '../types';

const SelectDropdownIndicator = <T, V, L>(
  props: DropdownIndicatorProps<
    SelectOption<T, V, L>,
    false,
    GroupBase<SelectOption<T, V, L>>
  >,
) => {
  const selectProps = props?.selectProps as unknown as SelectProps<T, V, L>;
  const customIndicator =
    selectProps?.isMenuOpen && selectProps?.indicatorOpenState
      ? selectProps?.indicatorOpenState
      : selectProps?.indicator;
  const color = props.isFocused ? 'var(--primary)' : '#6B6B95';

  return (
    <>
      {!selectProps.isLoading ? (
        <components.DropdownIndicator {...props}>
          {selectProps?.indicator && customIndicator ? (
            <CustomIconContainer
              $shouldRotate={Boolean(
                selectProps.isMenuOpen && !selectProps?.indicatorOpenState,
              )}
            >
              <CustomIcon
                color="#6B6B95"
                name={customIndicator as IconNames}
                size={selectProps?.indicatorSize}
              />
            </CustomIconContainer>
          ) : (
            <DisplayIcon
              $shouldRotate={Boolean(selectProps.isMenuOpen)}
              className="kiosko:mr-10 kiosko:-mt-3"
            >
              <StyledCustomIcon
                color={color}
                name="arrow"
                size="18px"
                className="kiosko:w-10 kiosko:h-10"
              />
            </DisplayIcon>
          )}
        </components.DropdownIndicator>
      ) : null}
    </>
  );
};

export {SelectDropdownIndicator};
